module.exports = require('./_global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/library/modules/_html.js
 ** module id = 323
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/library/modules/_html.js
 ** module id = 323
 ** module chunks = 1
 **/